
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

interface Recipe {
  id: number;
  name: string;
  ingredients: string[];
  instructions: string[];
}

const AddRecipe: React.FC = () => {
  const [recipes, setRecipes] = useState<Recipe[]>([]);
  const [newRecipe, setNewRecipe] = useState({ name: '', ingredients: '', instructions: '' });

  useEffect(() => {
    axios.get('http://localhost:8000/api/recipes')
      .then(response => {
        const parsedRecipes = response.data.map((recipe: any) => ({
          ...recipe,
          ingredients: JSON.parse(recipe.ingredients),
          instructions: JSON.parse(recipe.instructions),
        }));
        setRecipes(parsedRecipes);
      })
      .catch(error => console.error('Error fetching recipes:', error));
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewRecipe({ ...newRecipe, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const recipeToAdd = {
      name: newRecipe.name,
      ingredients: newRecipe.ingredients.split('\n'),
      instructions: newRecipe.instructions.split('\n'),
    };

    axios.post('http://localhost:8000/api/recipes', recipeToAdd)
      .then(response => setRecipes([...recipes, response.data]))
      .catch(error => console.error('Error adding recipe:', error));

    setNewRecipe({ name: '', ingredients: '', instructions: '' });
  };

  return (
    <div className="container mt-5">
      <h2>Add a New Recipe</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Recipe Name</label>
          <input type="text" className="form-control" id="name" name="name" value={newRecipe.name} onChange={handleInputChange} required />
        </div>
        <div className="mb-3">
          <label htmlFor="ingredients" className="form-label">Ingredients (one per line)</label>
          <textarea className="form-control" id="ingredients" name="ingredients" value={newRecipe.ingredients} onChange={handleInputChange} rows={5} required />
        </div>
        <div className="mb-3">
          <label htmlFor="instructions" className="form-label">Instructions (one per line)</label>
          <textarea className="form-control" id="instructions" name="instructions" value={newRecipe.instructions} onChange={handleInputChange} rows={5} required />
        </div>
        <button type="submit" className="btn btn-primary">Add Recipe</button>
      </form>
    </div>
  );
};

export default AddRecipe;
